module.exports = __webpack_public_path__ + "static/media/connatix-logo.9d1d2ca9.svg";